import { Component, Input, OnInit } from '@angular/core';
import {
  CAR_TYPE,
  MarketPlaceQuoteRequestService,
} from 'src/app/services/market-place-quote-request-service/market-place-quote-request.service';

import { REQUEST_STEPS } from '../enum-request-steps';
import { Router } from '@angular/router';

@Component({
  selector: 'app-side-navigation',
  templateUrl: './side-navigation.component.html',
  styleUrls: ['./side-navigation.component.scss'],
})
export class SideNavigationComponent implements OnInit {
  @Input() currentStep: REQUEST_STEPS = REQUEST_STEPS.SELECTION;

  enum_request_steps = REQUEST_STEPS;

  displayReturnToSearch = false;
  selectedCarType: any;
  enum_car_type = CAR_TYPE;

  constructor(
    public quoteRequestService: MarketPlaceQuoteRequestService,
    private router: Router
  ) {
    this.selectedCarType = this.quoteRequestService.getSelectedCarType();
  }

  ngOnInit(): void {}

  goToStep(step: REQUEST_STEPS) {
    if (!this.quoteRequestService.canNavigate(step)) {
      return false;
    }
    this.currentStep = step;
    this.quoteRequestService.setNextStep(step);
    return true;
  }

  navigateHome() {
    this.router.navigate(['/search-inventory/search-cars'], {
      state: { refresh: true },
    });
  }

  showBackModal() {
    this.displayReturnToSearch = true;
  }
}
